/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction, props } from '@ngrx/store';
import { common } from '@qwyk/models';
import {
    Shipment,
    ShipmentData,
    ShipmentTrackingRequest,
    ShipmentTrackingRequestResponse,
} from './shipments.models';

export const loadShipments = createAction(
    '[Portals/Shipments] Load Shipments',
    props<{ query: any }>()
);

export const loadShipmentsSuccess = createAction(
    '[Portals/Shipments] Load Shipments Success',
    props<{
        shipments: Shipment[];
        pagination: common.PaginationMeta;
        customFields: common.CustomFieldDefinition[];
        customViews: common.CustomView[];
    }>()
);

export const loadShipmentsFailure = createAction(
    '[Portals/Shipments] Load Shipments Failure',
    props<{ error: any }>()
);

export const loadShipmentSuccess = createAction(
    '[Portals/Shipments] Load Shipment Success',
    props<{ shipment: Shipment }>()
);
export const loadShipmentFailure = createAction(
    '[Portals/Shipments] Load Shipment Failure',
    props<{ error: any }>()
);

export const selectShipment = createAction(
    '[Portals/Shipments] Select Shipment',
    props<{ selectedId: string }>()
);
export const unselectShipment = createAction(
    '[Portals/Shipments] Unselect Shipment'
);

export const resetLoadShipmentsQuery = createAction(
    '[Portals/Shipments] Reset Load Shipments Query'
);

export const updateShipmentReferences = createAction(
    '[Portals/Shipments] Update Shipment References',
    props<{ shipmentId: string; update: Partial<Shipment> }>()
);

export const updateShipmentPartiallySuccess = createAction(
    '[Portals/Shipments] Update Shipment Partially Success',
    props<{ shipmentId: string; update: Partial<Shipment> }>()
);

export const updateShipmentPartiallyFailure = createAction(
    '[Portals/Shipments] Update Shipment Partially Failure',
    props<{ error: any }>()
);

export const generateShipmentPdf = createAction(
    '[Portals/Shipments] Generate Shipment Pdf',
    props<{ shipmentId: string }>()
);
export const generateShipmentPdfSuccess = createAction(
    '[Portals/Shipments] Generate Shipment Pdf Success',
    props<{ blob: Blob }>()
);
export const generateShipmentPdfFailure = createAction(
    '[Portals/Shipments] Generate Shipment Pdf Failure',
    props<{ error: any }>()
);

export const sendTrackingRequest = createAction(
    '[Portals/Shipments] Send Tracking Request',
    props<{ shipmentId: string; trackingRequest: ShipmentTrackingRequest }>()
);

export const sendTrackingRequestSuccess = createAction(
    '[Portals/Shipments] Send Tracking Request Success',
    props<{ shipmentId: string; response: ShipmentTrackingRequestResponse }>()
);

export const sendTrackingRequestFailure = createAction(
    '[Portals/Shipments] Send Tracking Request Failure',
    props<{ error: any }>()
);

export const cancelTrackingRequest = createAction(
    '[Portals/Shipments] Cancel Tracking Request',
    props<{ shipmentId: string }>()
);

export const cancelTrackingRequestSuccess = createAction(
    '[Portals/Shipments] Cancel Tracking Request Success',
    props<{ shipmentId: string; response: ShipmentTrackingRequestResponse }>()
);

export const cancelTrackingRequestFailure = createAction(
    '[Portals/Shipments] Cancel Tracking Request Failure',
    props<{ error: any }>()
);

export const updateShipmentDataTransport = createAction(
    '[Portals/Shipments] Update Shipment Data Transport',
    props<{ shipmentId: string; changes: Partial<ShipmentData> }>()
);
export const updateShipmentDataTransportSuccess = createAction(
    '[Portals/Shipments] Update Shipment Data Transport Success',
    props<{ shipmentId: string; data: ShipmentData }>()
);
export const updateShipmentDataTransportFailure = createAction(
    '[Portals/Shipments] Update Shipment Data Transport Failure',
    props<{ error: any }>()
);

export const updateShipmentDataReferences = createAction(
    '[Portals/Shipments] Update Shipment Data References',
    props<{ shipmentId: string; changes: Partial<ShipmentData> }>()
);
export const updateShipmentDataReferencesSuccess = createAction(
    '[Portals/Shipments] Update Shipment Data References Success',
    props<{ shipmentId: string; data: ShipmentData }>()
);
export const updateShipmentDataReferencesFailure = createAction(
    '[Portals/Shipments] Update Shipment Data References Failure',
    props<{ error: any }>()
);

export const assignShipmentOperator = createAction(
    '[Portals/Shipments] Assign Shipment Operator',
    props<{ shipmentId: string; operatorId: number }>()
);

export const assignShipmentOperatorSuccess = createAction(
    '[Portals/Shipments] Assign Shipment Operator Success',
    props<{ shipment: Shipment }>()
);

export const assignShipmentOperatorFailure = createAction(
    '[Portals/Shipments] Assign Shipment Operator Failure',
    props<{ error: any }>()
);

export const completeShipment = createAction(
    '[Portals/Shipments] Complete Shipment',
    props<{ shipmentId: string }>()
);
export const completeShipmentSuccess = createAction(
    '[Portals/Shipments] Complete Shipment Success',
    props<{ shipment: Shipment }>()
);
export const completeShipmentFailure = createAction(
    '[Portals/Shipments] Complete Shipment Failure',
    props<{ error: any }>()
);

export const cancelShipment = createAction(
    '[Portals/Shipments] Cancel Shipment',
    props<{ shipmentId: string }>()
);
export const cancelShipmentSuccess = createAction(
    '[Portals/Shipments] Cancel Shipment Success',
    props<{ shipment: Shipment }>()
);
export const cancelShipmentFailure = createAction(
    '[Portals/Shipments] Cancel Shipment Failure',
    props<{ error: any }>()
);

export const updateShipmentName = createAction(
    '[Portals/Shipments] Update Shipment Name',
    props<{ shipmentId: string; update: Partial<Shipment> }>()
);

export const tagShipment = createAction(
    '[Portals/Shipments] Tag Shipment',
    props<{ entityId: string; tag: common.CustomTag }>()
);

export const untagShipment = createAction(
    '[Portals/Shipments] Remove Tag from Shipment',
    props<{ entityId: string; tagId: string }>()
);

export const resetAction = createAction('[Portals/Shipments] Reset Action');

export const resetPaginationAction = createAction(
    '[Portals/Shipments] Reset Pagination Action'
);

export const resetStateButKeepQuery = createAction(
    '[Portals/Shipments] Reset State But Keep Query'
);

export const dismissError = createAction('[Portals/Shipments] Dismiss Error');
